export enum ExtraTripCategory {
  VacancyCovering = 'VacancyCovering',
  Absenteeism = 'Absenteeism',
  SpecialServices = 'SpecialServices',
}
